import { useTranslation } from 'react-i18next';
import { Col, Flex, Row, theme, Typography } from 'antd';
import type { TradingTimesModel } from 'pos-shared/models/openingHoursGroupSchema';

interface LocationHourGroupProps {
  groupName: string;
  groupHours: TradingTimesModel[];
  color: 'green' | 'gold';
  changeFrom?: boolean;
}

/** Copied from `LocationHoursModal.tsx` to fix error of component created on render */
export const LocationHourGroup = ({
  groupName,
  groupHours,
  color,
  changeFrom,
}: LocationHourGroupProps) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  return (
    <Row
      justify="center"
      align="middle"
      style={{
        flexDirection: 'column',
        textAlign: 'center',
        backgroundColor: token[`${color}-1`],
        borderRadius: token.borderRadiusLG,
        borderBottom: `1px solid ${token[`${color}-8`]}`,
        paddingTop: '60px', // No Token for this
        paddingBottom: '60px', // No Token for this
      }}
    >
      <Col>
        <Typography.Text style={{ display: 'block' }}>
          {changeFrom ? t('locations.changeFrom') : t('locations.changeTo')}
        </Typography.Text>
        <Typography.Text style={{ fontSize: token.fontSizeLG }}>
          <Typography.Text strong style={{ fontSize: 'inherit' }}>
            {t('locations.currentGroup')}
          </Typography.Text>
          {groupName}
        </Typography.Text>
      </Col>
      <Col
        style={{
          marginTop: token.marginLG,
          width: '100%',
        }}
      >
        {groupHours?.map((hourGroup) => (
          <Flex key={hourGroup.dayOfWeek} justify="center">
            <Typography.Text strong style={{ marginRight: token.margin }}>
              {hourGroup.dayOfWeek}
            </Typography.Text>
            {hourGroup.opening !== '--' && hourGroup.closing !== '--' ? (
              <>
                {hourGroup.opening} - {hourGroup.closing}
              </>
            ) : (
              t('statuses.closed')
            )}
          </Flex>
        ))}
      </Col>
    </Row>
  );
};
